import createLssFromMapSubTool from "@/tools/create/lss-from-map";
import { LargeSiteScreenTableHeader } from "@/tools/risk-bands/large-site-screen/components/LargeSiteScreenTableHeader";
import { LargeSiteScreenTutorial } from "@/tools/risk-bands/large-site-screen/components/LargeSiteScreenTutorial";
import { Tool, ToolProps } from "@/types/tools";
import { GatewayOutlined, GlobalOutlined } from "@ant-design/icons";
import { getConfig } from "@/features/branding";
import portfolioExportTool, { PortfolioExportTool } from "../../aggregate/portfolio-export";
const largeSiteScreenTool = {
  ...portfolioExportTool,
  id: "large-site-screen",
  category: "screening",
  keyPrefix: "screening.largeSite",
  icon: <GatewayOutlined />,
  hasTutorial: true,
  banner: {
    // getConfig() is only available at runtime.
    enabled: () => !getConfig().pages.collections.enabled,
    icon: <GlobalOutlined />,
    tag: "Coming soon",
    description: "Geospatial visualisations of risk distribution across Large Sites will be available as an enhancement to the tool in June 2025."
  },
  render: (props: ToolProps) => <>
      <PortfolioExportTool key="large-site" mode="large-site" tableHeaderComponent={LargeSiteScreenTableHeader} {...props} />
      <LargeSiteScreenTutorial onClose={() => props.setIsTutorialOpen(false)} open={props.isTutorialOpen} setState={
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    () => {}} />
    </>,
  subTools: [createLssFromMapSubTool]
} as Tool;
export default largeSiteScreenTool;